import React, { Component } from "react";
import EmailNotifications from '../home/EmailNotifications';
import AccountSecurity from '../home/AccountSecurity';
import FitnessInfo from '../home/FitnessInfo';
import PersonalInfo from '../home/PersonalInfo';
import MainLoader from '../home/MainLoader';

class SettingsContent extends Component {
  
  constructor(props) {
	super(props);
	this.userInfo = React.createRef();
	this.state={
		showLoader: false
    }
	
}
 
updateStateFromChild=(state)=>{
	this.setState(state);
}

resetUserInfo=()=>{
	if ( this && this.userInfo && this.userInfo.current ) 
		{ 
			this.userInfo.current.closeEditInfo(); 
		}
}

  render() {
	 return (
		<div className="settings_right_content">
			<div className="settins_title">{this.props.chosenMenu}</div>
			<div className={( this.props.chosenMenu !== 'Personal Info' ? "d-none" : "" )}>
				<PersonalInfo ref={this.userInfo} updateStateFromChild={this.updateStateFromChild}></PersonalInfo>
			</div>
			<div className={( this.props.chosenMenu !== 'Fitness Info' ? "d-none" : "" )}>
				<FitnessInfo updateStateFromChild={this.updateStateFromChild}></FitnessInfo>
			</div>
			<div className={( this.props.chosenMenu !== 'Email Notifications' ? "d-none" : "" )}>
				<EmailNotifications></EmailNotifications>
			</div>
			<div className={( this.props.chosenMenu !== 'Account Security' ? "d-none" : "" )}>
				<AccountSecurity></AccountSecurity>
			</div>
			{ this.state.showLoader && <MainLoader></MainLoader> }
		</div>
    );
  }
}
export default SettingsContent;
